import { render, staticRenderFns } from "./FormCOSCases.vue?vue&type=template&id=e3e71f2a&lang=pug"
import script from "./FormCOSCases.vue?vue&type=script&lang=ts"
export * from "./FormCOSCases.vue?vue&type=script&lang=ts"
import style0 from "./FormCOSCases.vue?vue&type=style&index=0&id=e3e71f2a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports